import { useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";

// Owns the two AI actions in the RFP modal: carrier recommendation and note drafting.
export function useRfpAi(rfpData, emailCarriers, addSelections) {
  const [aiNotes, setAiNotes] = useState("");
  const [drafting, setDrafting] = useState(false);
  const [recommendedIds, setRecommendedIds] = useState([]);
  const [rationale, setRationale] = useState("");
  const [recommending, setRecommending] = useState(false);

  const aiRecommend = async () => {
    setRecommending(true);
    try {
      const { data } = await api.post("/ai/recommend-carrier", {
        pickup: rfpData.pickup,
        destination: (rfpData.stops || []).find((s) => s && s.trim()) || "",
        units: rfpData.units,
      });
      const ids = data.recommended_ids || [];
      setRecommendedIds(ids);
      setRationale(data.rationale || "");
      const withEmail = ids.filter((id) => emailCarriers.some((c) => c.id === id));
      if (withEmail.length) {
        addSelections(withEmail);
        toast.success(`Selected ${withEmail.length} AI-recommended carrier(s)`);
      } else if (ids.length) {
        toast.info("AI recommended carriers, but none have an email on file yet — add emails in the Carrier Directory");
      } else {
        toast.info("AI could not match a specific carrier — see the rationale below");
      }
    } catch (err) {
      toast.error(err.response?.data?.detail || "Could not get AI recommendations");
    } finally {
      setRecommending(false);
    }
  };

  const draftNotes = async () => {
    setDrafting(true);
    try {
      const { data } = await api.post("/ai/draft-rfp", {
        pickup: rfpData.pickup,
        stops: rfpData.stops,
        units: rfpData.units,
        pickup_date: rfpData.schedule?.pickupDate || "",
        delivery_date: rfpData.schedule?.deliveryDate || "",
      });
      setAiNotes(data.draft);
      toast.success("AI notes added to the RFP");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Could not draft notes");
    } finally {
      setDrafting(false);
    }
  };

  return { aiNotes, drafting, recommendedIds, rationale, recommending, aiRecommend, draftNotes };
}
